'use client';

import { createContext, useContext } from 'react';
import type { MatchedPlay } from 'src/api/redux/profileConfiguration/types';

type PlayNavigationHandler = (play: MatchedPlay) => void;

const PlayNavigationContext = createContext<PlayNavigationHandler | null>(null);

export const usePlayNavigation = () => useContext(PlayNavigationContext);

interface PlayNavigationProviderProps {
  onNavigate: PlayNavigationHandler;
  children: React.ReactNode;
}

export const PlayNavigationProvider: React.FC<PlayNavigationProviderProps> = ({
  onNavigate,
  children,
}) => (
  <PlayNavigationContext.Provider value={onNavigate}>
    {children}
  </PlayNavigationContext.Provider>
);
